import { useTranslation } from 'react-i18next'
import { MangoModal } from '~/components/shared/MangoModal'

import { PbxPicker } from './PbxPicker'
import { usePbxSwitcher } from './usePbxSwitcher'

interface SwitchPbxModalProps {
  open: boolean
  onClose: () => void
}

export const SwitchPbxModal = ({ open, onClose }: SwitchPbxModalProps) => {
  const { t } = useTranslation()

  // Call the hook at the SwitchPbxModal level (not inside MangoModal): the
  // dialog content unmounts on close, so any state owned by the picker would
  // be lost before the user clicks Confirm in the follow-up confirmation
  // modal. This component is rendered persistently by its parents.
  const { currentPbx, handleSelect } = usePbxSwitcher({
    onAfterSwitchInitiated: onClose,
  })

  return (
    <MangoModal
      open={open}
      onOpenChange={({ open: isOpen }) => !isOpen && onClose()}
      header={t('pbxPicker.switchPbx', 'Switch PBX')}
      scrollable
    >
      <PbxPicker currentPbx={currentPbx} onSelect={handleSelect} />
    </MangoModal>
  )
}
